var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileEdgeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 2.02L14 2C11.8 2 10 3.8 10 6V42C10 44.2 11.8 46 14 46H34C36.2 46 38 44.2 38 42V6C38 3.8 36.2 2.02 34 2.02ZM34 38H14V10H34V38Z",
    fill: "#495058"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_206_1040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4437 27.9062C30.2291 28.0177 30.0079 28.1159 29.7812 28.2C29.0634 28.4672 28.3033 28.6027 27.5375 28.6C24.5812 28.6 22.0062 26.5688 22.0062 23.9563C22.01 23.6064 22.107 23.2639 22.2872 22.964C22.4673 22.6642 22.7242 22.4177 23.0312 22.25C20.3562 22.3625 19.6687 25.15 19.6687 26.7812C19.6687 31.4062 23.925 31.8687 24.8437 31.8687C25.3375 31.8687 26.0812 31.725 26.5312 31.5813L26.6125 31.5562C28.3346 30.9611 29.8027 29.7972 30.775 28.2563C30.8032 28.2094 30.8153 28.1546 30.8095 28.1003C30.8036 28.0459 30.7801 27.9949 30.7425 27.9552C30.7049 27.9155 30.6553 27.8892 30.6013 27.8804C30.5474 27.8715 30.492 27.8806 30.4437 27.9062Z",
    fill: "url(#paint0_linear_206_1040)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M30.4437 27.9062C30.2291 28.0177 30.0079 28.1159 29.7812 28.2C29.0634 28.4672 28.3033 28.6027 27.5375 28.6C24.5812 28.6 22.0062 26.5688 22.0062 23.9563C22.01 23.6064 22.107 23.2639 22.2872 22.964C22.4673 22.6642 22.7242 22.4177 23.0312 22.25C20.3562 22.3625 19.6687 25.15 19.6687 26.7812C19.6687 31.4062 23.925 31.8687 24.8437 31.8687C25.3375 31.8687 26.0812 31.725 26.5312 31.5813L26.6125 31.5562C28.3346 30.9611 29.8027 29.7972 30.775 28.2563C30.8032 28.2094 30.8153 28.1546 30.8095 28.1003C30.8036 28.0459 30.7801 27.9949 30.7425 27.9552C30.7049 27.9155 30.6553 27.8892 30.6013 27.8804C30.5474 27.8715 30.492 27.8806 30.4437 27.9062Z",
    fill: "url(#paint1_radial_206_1040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6062 31.0814C22.0499 30.7358 21.5676 30.2833 21.1874 29.7501C20.7533 29.1558 20.4544 28.4738 20.3118 27.7518C20.1693 27.0297 20.1864 26.2853 20.3621 25.5706C20.5378 24.8559 20.8678 24.1883 21.3289 23.6147C21.79 23.0411 22.371 22.5753 23.0312 22.2501C23.2312 22.1563 23.5624 21.9938 24.0062 22.0001C24.3184 22.0025 24.6259 22.0771 24.9046 22.2181C25.1832 22.359 25.4255 22.5625 25.6124 22.8126C25.8639 23.1508 26.0018 23.5599 26.0062 23.9813C26.0062 23.9688 27.5374 19.0063 21.0062 19.0063C18.2624 19.0063 16.0062 21.6063 16.0062 23.8938C15.9953 25.1022 16.2536 26.2978 16.7624 27.3938C17.5957 29.1682 19.0515 30.5749 20.8535 31.3468C22.6554 32.1188 24.678 32.2022 26.5374 31.5814C25.886 31.7871 25.1977 31.8489 24.52 31.7626C23.8423 31.6763 23.1915 31.4438 22.6124 31.0814H22.6062Z",
    fill: "url(#paint2_linear_206_1040)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M22.6062 31.0814C22.0499 30.7358 21.5676 30.2833 21.1874 29.7501C20.7533 29.1558 20.4544 28.4738 20.3118 27.7518C20.1693 27.0297 20.1864 26.2853 20.3621 25.5706C20.5378 24.8559 20.8678 24.1883 21.3289 23.6147C21.79 23.0411 22.371 22.5753 23.0312 22.2501C23.2312 22.1563 23.5624 21.9938 24.0062 22.0001C24.3184 22.0025 24.6259 22.0771 24.9046 22.2181C25.1832 22.359 25.4255 22.5625 25.6124 22.8126C25.8639 23.1508 26.0018 23.5599 26.0062 23.9813C26.0062 23.9688 27.5374 19.0063 21.0062 19.0063C18.2624 19.0063 16.0062 21.6063 16.0062 23.8938C15.9953 25.1022 16.2536 26.2978 16.7624 27.3938C17.5957 29.1682 19.0515 30.5749 20.8535 31.3468C22.6554 32.1188 24.678 32.2022 26.5374 31.5814C25.886 31.7871 25.1977 31.8489 24.52 31.7626C23.8423 31.6763 23.1915 31.4438 22.6124 31.0814H22.6062Z",
    fill: "url(#paint3_radial_206_1040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.525 25.3C25.4688 25.3625 25.3125 25.4562 25.3125 25.65C25.3125 25.8125 25.4187 25.975 25.6125 26.1062C26.5062 26.7312 28.2 26.6438 28.2062 26.6438C28.8725 26.6433 29.5265 26.4642 30.1 26.125C30.6774 25.7873 31.1565 25.3045 31.4897 24.7246C31.823 24.1446 31.9989 23.4876 32 22.8187C32.0187 21.4187 31.5 20.4875 31.2937 20.075C29.9625 17.4875 27.1062 16 24 16C21.8976 15.9998 19.8797 16.8272 18.3826 18.3032C16.8855 19.7793 16.0296 21.7853 16 23.8875C16.0312 21.6062 18.3 19.7625 21 19.7625C21.2188 19.7625 22.4688 19.7812 23.625 20.3875C24.4373 20.7912 25.11 21.429 25.5562 22.2188C25.9375 22.8812 26.0062 23.725 26.0062 24.0625C26.0062 24.4 25.8375 24.8937 25.5187 25.3062L25.525 25.3Z",
    fill: "url(#paint4_radial_206_1040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.525 25.3C25.4688 25.3625 25.3125 25.4562 25.3125 25.65C25.3125 25.8125 25.4187 25.975 25.6125 26.1062C26.5062 26.7312 28.2 26.6438 28.2062 26.6438C28.8725 26.6433 29.5265 26.4642 30.1 26.125C30.6774 25.7873 31.1565 25.3045 31.4897 24.7246C31.823 24.1446 31.9989 23.4876 32 22.8187C32.0187 21.4187 31.5 20.4875 31.2937 20.075C29.9625 17.4875 27.1062 16 24 16C21.8976 15.9998 19.8797 16.8272 18.3826 18.3032C16.8855 19.7793 16.0296 21.7853 16 23.8875C16.0312 21.6062 18.3 19.7625 21 19.7625C21.2188 19.7625 22.4688 19.7812 23.625 20.3875C24.4373 20.7912 25.11 21.429 25.5562 22.2188C25.9375 22.8812 26.0062 23.725 26.0062 24.0625C26.0062 24.4 25.8375 24.8937 25.5187 25.3062L25.525 25.3Z",
    fill: "url(#paint5_radial_206_1040)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_206_1040",
    x1: 19.6687,
    y1: 27.0625,
    x2: 30.8187,
    y2: 27.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C59A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114A8B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_206_1040",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.825 27.1466) scale(5.9625 5.66437)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_206_1040",
    x1: 25.5437,
    y1: 22.2251,
    x2: 18.5874,
    y2: 29.8063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1595DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0680D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_206_1040",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.4096 28.4337) rotate(-81.3844) scale(8.96163 7.24009)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_206_1040",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.6181 18.9573) rotate(92.2906) scale(12.6601 26.9634)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#34C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#2FC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2BC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#36C752"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_206_1040",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.0038 20.8312) rotate(73.7398) scale(6.08125 4.94527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66EB6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_1040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileEdgeIcon);
export default __webpack_public_path__ + "static/media/mobile_edge_icon.a4e4c7c6.svg";
export { ForwardRef as ReactComponent };